import React from "react";
import { Route, Switch } from "react-router-dom";

import ListUsers from "./routes/ListUsers";
import Payouts from "./routes/Payouts";
import Documents from "./routes/Documents";
import Attendance from "./routes/attendance"

const Users = ({ match }) => (
    <div className="app-wrapper">
      <Switch>
          <Route path={`${match.url}/list-users`} component={ListUsers}/>
          <Route path={`${match.url}/payouts`} component={Payouts}/>
          <Route path={`${match.url}/documents`} component={Documents}/>
          <Route path={`${match.url}/attendance`} component={Attendance}/>
      </Switch>
    </div>
  );
  
  export default Users;